<template>
  <div class="invoice-view">
    <v-card flat>
      <ReportViewBar
        :title="`Quaterly Taxes`"
        :location="location"
      />
      <!-- <v-card-text>
        <v-layout row wrap class="no-print">
          <v-spacer></v-spacer>
          <v-flex xs12 md3>
            <DateTimePicker
              :range="true"
              v-model="dateTime"
              :initStartDate="start"
              :initEndDate="end"
              @submit="loadReport()"
            />
          </v-flex>
        </v-layout>
      </v-card-text> -->
      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
      <div v-else>
        <v-container fluid>
          <v-expansion-panel focusable :expand="expand" popout class="elevation-0">
            <v-expansion-panel-content lazy v-for="(invoice, i) in reportsData" :key="i">
              <template v-slot:header>
                <v-layout row wrap>
                  <v-flex>
                    <h2 class="title font-weight-regular">
                      <span class="title font-weight-bold">{{ i }}</span>
                      ({{ invoice.data.length }})
                    </h2>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right mr-2" shrink>
                    <h2 class="title font-weight-regular">
                      {{ invoice.totals.taxCollected | currency }}
                    </h2>
                  </v-flex>
                </v-layout>
              </template>

              <v-divider></v-divider>

              <v-container fluid class="pa-0">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex class="text-left text-capitalize">
                      <div class="headline font-weight-light text-uppercase">
                        <span class="blue--text font-weight-medium">Revenue:</span>
                        {{ invoice.totals.revenue | currency }}
                      </div>
                      <div class="font-weight-medium">
                        <span class="blue--text font-weight-medium">Tax Collected:</span>
                        {{ invoice.totals.taxCollected | currency }}
                      </div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink class="text-right">
                      <div class="font-weight-regular" v-if="invoice.start">
                        <v-layout row justify-end>
                          <v-flex>
                            <div class="text-right px-2">FROM:</div>
                            <div class="text-right px-2">TO:</div>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink>
                            <div class="text-left">
                              {{ invoice.start | moment('LL') }}
                            </div>
                            <div class="text-left">
                              {{ invoice.end | moment('LL') }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-container>

              <table class="center">
                <tbody class="report-container">
                  <v-card-text class="pt-0">
                    <v-data-table :headers="headers" :items="invoice.data" :rows-per-page-items="rowsPerPageItems">
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">
                          {{ props.item.name }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.type }}
                        </td>
                        <td data-cy="expenseComponentsListPayeeName" class="text-xs-left">
                          {{ props.item.percentage }}
                        </td>
                        <td data-cy="expenseComponentsListPayeeName" class="text-xs-left">
                          {{ props.item.taxedItemCount }}
                        </td>
                        <td data-cy="expenseComponentsListAmount" class="text-xs-left">
                          {{ props.item.taxedAmount | currency }}
                        </td>
                        <td
                          data-cy="quaterlyComponentsListAmount"
                          class="text-xs-right text-md-right text-sm-right text-lg-right"
                        >
                          {{ taxTotal(props.item) | currency }}
                        </td>
                      </template>
                      <!-- <template slot="footer">
                        <tr>
                          <td :colspan="headers && headers.length - 2">
                            <div class="text-xs-right font-weight-bold">
                              {{ $t('labels.total') }}
                            </div>
                          </td>
                          <td class="text-xs-right font-weight-bold">
                            {{ totalTaxSum | currency }}
                          </td>
                          <td></td>
                        </tr>
                      </template> -->
                    </v-data-table>
                  </v-card-text>
                </tbody>
              </table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-divider></v-divider>
          <v-card flat class="px-5" color="grey lighten-4">
            <v-card-text>
              <v-layout row wrap>
                <v-flex>
                  <h2 class="headline font-weight-regular">{{ $t('labels.total') }}</h2>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="text-xs-right mr-2" shrink>
                  <h2 class="headline font-weight-regular">
                    {{ report_grandTotal_total | currency }}
                  </h2>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
      </div>

      <v-card-text v-if="reportsData.length === 0">
        <div class="text-xs-center mb-5">No Product Found</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from '@/components/ReportViewBar'
import DateTimePicker from '@/components/DateTimePicker'
import reportService from '../../../Reports/service'
import locationService from '@/modules/Location/service'
import { Decimal } from 'decimal.js'

export default {
  data() {
    return {
      taxInvoice: null,
      selectedRange: 'thisMonth',
      removeGroup: false,
      expand: false,
      reportsData: [],
      start: this.$moment().startOf('day'),
      end: this.$moment().endOf('day'),
      dateTime: {
        start: this.$moment().startOf('day').toISOString(),
        end: this.$moment().endOf('day').toISOString(),
      },
      loading: false,
      location: null,
      locationId: null,
      rowsPerPageItems: [10, 25, 50, 100],
      headers: [
        {
          text: this.$t('labels.name'),
          align: 'left',
          sortable: false,
          value: 'name',
          width: '20%',
        },
        {
          text: this.$t('labels.type'),
          value: 'type',
          sortable: false,
        },
        {
          text: this.$t('labels.rate'),
          value: 'rate',
          sortable: false,
        },
        {
          text: this.$t('labels.itemCount'),
          value: 'itemCount',
          sortable: false,
        },
        {
          text: this.$t('labels.taxSubtotal'),
          value: 'taxSubtotal',
          sortable: false,
        },
        {
          text: this.$t('labels.totalTax'),
          value: 'taxTotal',
          align: 'right',
          sortable: false,
        },
      ],
    }
  },
  components: {
    ReportViewBar,
    DateTimePicker,
  },
  created() {
    const { start, end, range, LocationId } = this.$route.query;
    this.locationId = LocationId;
    
    if (start && end) {
      this.dateTime.start = start
      this.dateTime.end = end
    } else {
      this.dateTime.start = this.$moment().startOf('month').toISOString()
      this.dateTime.end = this.$moment().endOf('month').toISOString()
    }

    if (this.locationId) {
      locationService.getbyId(this.locationId)
      .then(response => {
        this.location = response.data;
      })
      .catch(error => { throw error });
    }
    this.selectedRange = range;
    this.loadReport()
  },
  computed: {
    report_grandTotal_total() {
      var total = 0
      Object.values(this.reportsData).forEach((row) => {
        if (row.totals && row.totals.taxCollected) {
          total += parseFloat(row.totals.taxCollected)
        }
      })
      return total
    },
  },
  methods: {
    // totalTaxSum() {
    //   let total = new Decimal(0)
    //   total = total.plus(this.taxTotal)
    //   return total
    // },
    taxTotal(val) {
      let totalTax =
        val.type === 'PERCENTAGE'
          ? new Decimal(val.percentage).dividedBy(100).times(val.taxedAmount).toFixed(2)
          : new Decimal(val.amount).times(val.taxedItemCount).toFixed(2)
      return totalTax
    },
    async loadReport() {
      this.$Progress.start()
      this.loading = true

      await reportService.Location.taxes({
        LocationId: this.locationId,
        start: this.dateTime.start,
        end: this.dateTime.end,
        quarters: true,
        year: this.$moment(this.start).format('YYYY'),
      })
        .then((response) => {
          this.$Progress.finish()
          this.loading = false
          this.taxInvoice = response
          this.reportsData = response.data
        })
        .catch((error) => {
          this.$Progress.fail
          this.loading = false
          throw error
        })
    },
  },
}
</script>

<style>
</style>